var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 4.5,
    fill: "#F1F1F1",
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13.5833C9.85 8.91665 16.15 8.91665 18.25 13.5833",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.9166C12.7702 15.9166 12.5426 15.8714 12.3303 15.7834C12.118 15.6955 11.9251 15.5666 11.7626 15.4041C11.6001 15.2416 11.4712 15.0486 11.3832 14.8363C11.2953 14.624 11.25 14.3964 11.25 14.1666C11.25 13.9368 11.2953 13.7092 11.3832 13.4969C11.4712 13.2846 11.6001 13.0917 11.7626 12.9292C11.9251 12.7667 12.118 12.6378 12.3303 12.5498C12.5426 12.4619 12.7702 12.4166 13 12.4166C13.4641 12.4166 13.9092 12.601 14.2374 12.9292C14.5656 13.2574 14.75 13.7025 14.75 14.1666C14.75 14.6308 14.5656 15.0759 14.2374 15.4041C13.9092 15.7323 13.4641 15.9166 13 15.9166Z",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewbox);
export default __webpack_public_path__ + "static/media/viewbox.1be8cf2389cfc9befe6afe8a12999bd5.svg";
export { ForwardRef as ReactComponent };